import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";

class LoginService {
    static async login(loginRequest) {
        try {
            const loginUrl = API_ENDPOINTS.getLogin();
            const response = await axiosInstance.post(loginUrl, loginRequest, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error occurred:", error);

            // If the server responded with an error status (4xx/5xx),
            // return its body so callers can still read statusCode/message
            if (error.response && error.response.data) {
                return error.response.data;
            }

            // Network error, timeout, or no response at all
            return {
                statusCode: 0,
                message: "Unable to reach the server. Please check your connection and try again.",
                result: null,
            };
        }
    }
}

export default LoginService;